import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/home/src/components/chat/chat.tsx");
